/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export const NumberInput = ({ id, label, value, onChange, unit, min, max, step = 1 }) => (
  <div className="space-y-1.5">
    <Label htmlFor={id} className="text-xs">{label}{unit ? ` (${unit})` : ''}</Label>
    <Input
      id={id}
      type="number"
      inputMode="decimal"
      value={value ?? ''}
      onChange={(e) => onChange(e.target.value === '' ? null : Number(e.target.value))}
      min={min}
      max={max}
      step={step}
      data-testid={`calc-input-${id}`}
    />
  </div>
);

export const ResultBox = ({ value, unit, interpretation, tone = 'neutral' }) => {
  const tones = {
    neutral: 'bg-secondary/40 border-border',
    good: 'bg-emerald-500/10 border-emerald-500/30 text-emerald-700 dark:text-emerald-300',
    warning: 'bg-amber-500/10 border-amber-500/30 text-amber-700 dark:text-amber-300',
    danger: 'bg-red-500/10 border-red-500/30 text-red-700 dark:text-red-300',
  };
  if (value === null || value === undefined || Number.isNaN(value)) {
    return (
      <div className="rounded-xl border border-dashed border-border p-4 text-center text-sm text-muted-foreground">
        Inserisci tutti i dati per calcolare
      </div>
    );
  }
  return (
    <div className={`rounded-xl border p-4 ${tones[tone] || tones.neutral}`} data-testid="calc-result">
      <div className="text-3xl font-display font-bold tabular-nums">
        {typeof value === 'number' ? value.toFixed(2) : value}
        {unit && <span className="text-lg font-normal ml-1 text-muted-foreground">{unit}</span>}
      </div>
      {interpretation && <div className="text-sm mt-1">{interpretation}</div>}
    </div>
  );
};
